module.exports = __webpack_public_path__ + "img/index_button.44b61b12.png";